export default __webpack_public_path__ + "static/media/failure-low.7a4840c3.2fa0bd2c.svg";